import angular = require('angular');

import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import { IRetailerRootScope } from '../core/models';
import { IMenuItem, IMenuListItem } from './models';

export class MenuService {
    public static $inject = [
        '$rootScope',
        'http',
        '$q',
        'retailerService'
    ];

    constructor(
        private $rootScope: IRetailerRootScope,
        private http: HttpService,
        private $q: ng.IQService,
        private retailerService: RetailerService
    ) {}

    public getMenus(isArchived: boolean) {
        return this.http.get<IMenuListItem[]>(
            this.retailerService.getMenus(isArchived)
        );
    }

    public getMenu(ID: string) {
        return this.http.get<IMenuItem>(this.retailerService.getMenu(ID));
    }

    public saveMenuImageUrl() {
        return this.retailerService.createMenuImage();
    }

    public getMenuImageUrl(imageId: string, width?: number, height?: number) {
        return this.retailerService.getMenuImage(imageId, width, height);
    }

    public saveMenu(item: IMenuItem) {
        if (item.ID == null) {
            return this.http.post<IMenuItem>(
                this.retailerService.createMenu(),
                item
            );
        } else {
            return this.http.put<IMenuItem>(
                this.retailerService.getMenu(item.ID.toString()),
                item
            );
        }
    }

    public setEnabledMenu(ID: string, value: boolean) {
        return this.http.post(
            this.retailerService.setEnabledMenu(ID, value),
            {}
        );
    }

    public setArchivedMenu(ID: string, value: boolean) {
        return this.http.post(
            this.retailerService.setArchivedMenu(ID, value),
            {}
        );
    }
}

angular.module('naut').service('menuService', MenuService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/menu.service.ts